import { mockBuilder } from '../../utils/builderHelper.es.js';
import '../../enums/billing/AccountGlobalStatusEnum.es.js';
import '../../enums/billing/AccountingStatusEnum.es.js';
import { AssetPurchaseFormatEnum } from '../../enums/billing/AssetPurchaseFormatEnum.es.js';
import '../../enums/billing/AssetPurchaseUnavailableCodeEnum.es.js';
import '../../enums/billing/BillingSystemEnum.es.js';
import '../../enums/billing/CreditKindEnum.es.js';
import '../../enums/billing/InvoiceStatusEnum.es.js';
import '../../enums/billing/DiscountTypeEnum.es.js';
import { PlanFrequencyEnum } from '../../enums/billing/PlanFrequencyEnum.es.js';
import '../../enums/billing/ServiceOffersKindEnum.es.js';
import '../../enums/billing/ServiceStatusEnum.es.js';
import '../../enums/billing/SubscriptionStatusEnum.es.js';
import '../../enums/billing/SubscriptionMigrationTypeEnum.es.js';
import '../../enums/billing/SubscriptionMigrationTimingEnum.es.js';
import '../../enums/billing/SubscriptionServiceOfferEnum.es.js';
import '../../enums/billing/BillingCommitmentEnum.es.js';
import '../../enums/collaboration/ActorEnum.es.js';
import '../../enums/collaboration/EntityTypeEnum.es.js';
import '../../enums/AppHomePageEnum.es.js';
import '../../enums/ApplicationEnum.es.js';
import '../../enums/CreditCardEnum.es.js';
import '../../enums/DollarSignCurrenciesEnum.es.js';
import '../../enums/DownloadBinStatusEnum.es.js';
import '../../enums/ExternalTypeEnum.es.js';
import '../../enums/FeatureEnum.es.js';
import '../../enums/FeatureFlagEnum.es.js';
import '../../enums/FileSelectionSourceEnum.es.js';
import '../../enums/GenresEnum.es.js';
import '../../enums/IntensityEnum.es.js';
import '../../enums/InternalErrorEnum.es.js';
import '../../enums/LibraryItemEnum.es.js';
import '../../enums/MasteringStyleEnum.es.js';
import '../../enums/MfeApplicationEnum.es.js';
import '../../enums/NotificationTypeEnum.es.js';
import '../../enums/PaymentCycleEnum.es.js';
import '../../enums/PaymentMethodEnum.es.js';
import '../../enums/ProofOfRightsEnums.es.js';
import '../../enums/RegexPatternsEnum.es.js';
import '../../enums/ReleaseContributorRoleEnum.es.js';
import '../../enums/ReleaseGlobalStateEnum.es.js';
import '../../enums/ReleaseLanguagesEnum.es.js';
import '../../enums/ReleasePayoutStatusEnum.es.js';
import '../../enums/ReleasePayoutGlobalStatusEnum.es.js';
import '../../enums/ReleaseStateEnum.es.js';
import '../../enums/ServiceProviderStateEnum.es.js';
import '../../enums/ReleaseStoreCategoryEnum.es.js';
import '../../enums/ReleaseStoreEnum.es.js';
import '../../enums/ReleaseTerritoriesEnum.es.js';
import '../../enums/ReleaseParentalWarningEnum.es.js';
import '../../enums/SessionFlagsEnum.es.js';
import '../../enums/ShareReactionTypeEnum.es.js';
import '../../enums/SocialNetworksEnum.es.js';
import '../../enums/StateEnum.es.js';
import '../../enums/TrackTypeEnum.es.js';
import '../../enums/UnavailabilityEnum.es.js';
import '../../enums/UserInteractionSourceEnum.es.js';
import '../../enums/ZeroDecimalCurrenciesEnum.es.js';
import '../../enums/NoiseReductionLevelEnum.es.js';
import '../../enums/ReleaseDspsEnum.es.js';
import '../../enums/ReleaseDspStatusEnum.es.js';
import '../../enums/ProjectsCallSourceTypesEnum.es.js';
import '../../enums/LibraryItemTypeEnum.es.js';
import '../../enums/PendingItemStateEnum.es.js';
import '../../enums/MonetizationEligibilityStateEnum.es.js';
import '../../enums/CoverSongOptionsEnum.es.js';
import '../../enums/LanguagesEnum.es.js';
import '../../enums/LocalesEnum.es.js';

/** @module Mocks */ /** typedoc */
function aPrismicTab() {
    return mockBuilder({
        tab: {
            uid: 'tab0',
        },
    });
}
function aPrismicPage() {
    return mockBuilder({
        tabs: [aPrismicTab()],
    });
}
function aPrismicDocument() {
    return mockBuilder({
        id: 'mock-document-id',
        type: 'prismic-type',
        data: aPrismicPage(),
    });
}
function aPrismicPrice() {
    return mockBuilder({
        amount: 0,
        currencyCode: 'USD-Main_Store',
        currencySymbol: '$',
        yearlyDiscountPercent: 0.35,
        yearlyDiscount: 169,
    });
}
function aPrismicQuantityRange() {
    return mockBuilder({
        min: 0,
        prices: [aPrismicPrice(), aPrismicPrice().withCurrencyCode('JPY-Asia)_JP').withCurrencySymbol('¥')],
    });
}
function aPrismicPricingPlanProduct() {
    return mockBuilder({
        code: AssetPurchaseFormatEnum.lomp3,
        name: AssetPurchaseFormatEnum.lomp3,
        description: 'MP3 192 Kbps master',
        pricingModel: 'Standard',
        quantityRanges: [aPrismicQuantityRange()],
        maxQuantity: undefined,
    });
}
function aPrismicPricingPlanFrequency() {
    return mockBuilder({
        interval: PlanFrequencyEnum.Monthly,
        planProducts: [
            aPrismicPricingPlanProduct()
                .withCode(AssetPurchaseFormatEnum.lomp3)
                .withName(AssetPurchaseFormatEnum.lomp3),
        ],
        prices: [aPrismicPrice(), aPrismicPrice().withCurrencyCode('JPY-Asia)_JP').withCurrencySymbol('¥')],
    });
}
function aPrismicPricingPlan() {
    return mockBuilder({
        code: 'mock-plan-code',
        frequencies: [
            aPrismicPricingPlanFrequency().withInterval(PlanFrequencyEnum.Monthly),
            aPrismicPricingPlanFrequency().withInterval(PlanFrequencyEnum.Yearly),
        ],
    });
}
function aPrismicProduct() {
    return mockBuilder({
        api_product: {
            code: AssetPurchaseFormatEnum.lomp3,
            name: AssetPurchaseFormatEnum.lomp3,
            description: 'MP3 192 Kbps master',
        },
        name: 'LO-MP3',
        unlimited_text: 'Unlimited',
        discount_text: 'OFF',
    });
}
function aPrismicPricingPlanFrequencyWithFreeProduct() {
    return aPrismicPricingPlanFrequency().withPlanProducts([
        aPrismicPricingPlanProduct().withQuantityRanges([
            aPrismicQuantityRange().withPrices([aPrismicPrice().withAmount(0)]),
        ]),
    ]);
}
function aPrismicPricingPlanFrequencyWithPaidProduct() {
    return aPrismicPricingPlanFrequency().withPlanProducts([
        aPrismicPricingPlanProduct().withQuantityRanges([
            aPrismicQuantityRange().withPrices([aPrismicPrice().withAmount(10)]),
        ]),
    ]);
}

export { aPrismicDocument, aPrismicPage, aPrismicPrice, aPrismicPricingPlan, aPrismicPricingPlanFrequency, aPrismicPricingPlanFrequencyWithFreeProduct, aPrismicPricingPlanFrequencyWithPaidProduct, aPrismicPricingPlanProduct, aPrismicProduct, aPrismicQuantityRange, aPrismicTab };
